import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppExtraLoadingService {
  load$ = new BehaviorSubject<'toasts' | 'contextMenus' | 'dialogs' | 'tooltips'>(undefined);
}
